import React, { useState } from 'react';
import { camelCase, isEmpty, kebabCase, pickBy, startCase } from 'lodash';
import { AnimatePresence, motion } from 'framer-motion';
import BoxedContainer from '../layouts/BoxedContainer';
import Icons from '../layouts/Icons';

export default function Faqs({ data }) {
  const [currIndex, setCurrIndex] = useState({});
  const filterByCategories = data.reduce((acc, { content }) => {
    const cat = content.category.toLowerCase().replace(/\s/g, '-');
    if (content.category === '' || content.category === 'General') {
      acc.general = [...(acc.general || []), content];
    } else {
      acc[cat] = [...(acc[cat] || []), content];
    }
    return acc;
  }, {});

  // console.log(filterByCategories);

  if (isEmpty(filterByCategories)) return null;

  return (
    <section
      className="bg-white lg:pt-[160px] pt-[90px] lg:pb-[218px] pb-[90px] lg:-mt-[80px]
     -mt-[20px]">
      <BoxedContainer className="faq">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-5">
          {Object.entries(filterByCategories).map(([keys, values], index) => {
            const isOpen = currIndex[index];
            const toggleTab = () => {
              setCurrIndex((prevOpenTabs) => ({
                ...prevOpenTabs,
                [index]: !isOpen,
              }));
            };
            return (
              <div key={index} className="flex flex-col gap-y-4">
                <button
                  type="button"
                  onClick={toggleTab}
                  style={{
                    fontSize: 'clamp(0.938rem, 0.122vw + 0.916rem, 1.063rem)',
                  }}
                  className="w-auto grow text-left text-black font-roboto-bold leading-[1.5]
                cursor-pointer flex justify-between border-b border-eggshell pb-5 px-2
                items-center gap-x-4 uppercase">
                  <span>{keys.replace(/-/g, ' ')}</span>
                  <Icons
                    icon={isOpen ? 'minus' : 'plus'}
                    className="!w-[24px] !min-w-[24px] -rotate-45 transition-all duration-500"
                  />
                </button>
                <AnimatePresence>
                  {isOpen &&
                    values.map((item) => (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5 }}
                        className="px-4">
                        <h4
                          className="w-auto text-left text-black font-roboto-bold leading-[1.5]
                        gap-x-4"
                          style={{
                            fontSize: 'clamp(0.875rem, 0.122vw + 0.854rem, 1rem)',
                          }}>
                          {item.question}
                        </h4>
                        <div
                          className="text-bg-10 leading-[1.75] font-roboto-regular
                          li-child:list-disc ul-child:pl-5 px-4"
                          style={{
                            fontSize: 'clamp(0.875rem, 0.122vw + 0.854rem, 1rem)',
                          }}
                          dangerouslySetInnerHTML={{ __html: item.answer }}
                        />
                      </motion.div>
                    ))}
                </AnimatePresence>
              </div>
            );
          })}
        </motion.div>
      </BoxedContainer>
    </section>
  );
}
